import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  profileHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  profileAvatar: {
    marginRight: theme.spacing(2),
    boxShadow: theme.shadows[4],
  },
  profileName: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  profileSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
  },
  infoCard: {
    height: "100%",
    minWidth: 0,
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[2],
  },
  cardContent: {
    padding: theme.spacing(1.5),
    minWidth: 0,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  cardIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "#070639",
    color: theme.palette.primary.contrastText,
    marginRight: theme.spacing(1.5),
  },
  cardLabel: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  cardValue: {
    minHeight: 20,
    minWidth: 0,
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    fontSize: "0.875rem",
    fontWeight: 400,
    color: theme.palette.text.secondary,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    lineHeight: 1.4,
  },
  emptyValue: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
  },
  specialSection: {
    marginBottom: theme.spacing(4),
  },
  specialSectionTitle: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    display: "flex",
    alignItems: "center",
  },
  specialSectionContent: {},
  scrollableContent: {
    padding: theme.spacing(1, 0),
    maxHeight: "400px",
    overflowY: "auto",
    paddingRight: theme.spacing(1),
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: theme.palette.grey[200],
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[400],
      borderRadius: "3px",
      "&:hover": {
        background: theme.palette.grey[600],
      },
    },
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    width: "100%",
    border: "1px solid #D9D9D9",
  },
  chip: {
    fontSize: "0.75rem",
    height: 28,
    fontWeight: 500,
    marginRight: 6,
    marginBottom: 6,
  },
  linkedinLink: {
    color: "#070639",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  linkedinIcon: {
    fontSize: 14,
    marginLeft: 4,
    color: "#070639",
  },
  actionButton: {
    marginRight: 15,
  },
}));
